/**
 * @generated SignedSource<<170a697d2d344fe3bdbd5b6bcaadbb3a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeartPill_nftItem$data = {
  readonly id: string;
  readonly likes: {
    readonly likeCount: number | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "HeartPill_nftItem";
};
export type HeartPill_nftItem$key = {
  readonly " $data"?: HeartPill_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeartPill_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItemLikes",
      "kind": "LinkedField",
      "name": "likes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "likeCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "c97bcf6b50df6e4268f525632c4b6671";

export default node;
